import script from "./ManualPaymentModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ManualPaymentModal.vue?vue&type=script&setup=true&lang=js"

import "./ManualPaymentModal.vue?vue&type=style&index=0&id=51c828f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-51c828f6"]])

export default __exports__